import React from 'react';
import { LogOut, MonitorSmartphone, UserCog } from 'lucide-react';
import api, { errorText } from '../services/api';
import { useApi } from '../lib/useApi';
import { ago, dateTime } from '../lib/format';
import { useAuth } from '../context/AuthContext';
import { Button, Card, Chip, ErrorBanner, PageHeader, PageSkeleton, useToast } from '../components/ui';
import { browserOf } from './Security';

interface Sess { id: string; created_at: string; last_seen_at: string | null; expires_at: string; ip_address: string; user_agent: string; current: boolean }

export default function Account() {
  const { user } = useAuth();
  const toast = useToast();
  const sessions = useApi<{ sessions: Sess[] }>('/me/sessions');

  const revokeOthers = async () => {
    try { const r = await api.post('/me/sessions/revoke-others'); toast('ok', `Signed out ${r.data.revoked} other session${r.data.revoked === 1 ? '' : 's'}`); sessions.reload(); }
    catch (e) { toast('error', errorText(e)); }
  };

  if (sessions.loading) return <PageSkeleton />;
  const list = sessions.data?.sessions || [];

  return (
    <div>
      <PageHeader title="Your account" subtitle={`${user?.name || 'Super admin'} · ${user?.email}`} />
      <Card title="Your signed-in browsers" icon={MonitorSmartphone} tone="green"
        right={list.length > 1 ? <Button size="sm" icon={LogOut} onClick={revokeOthers}>Sign out others</Button> : null} bodyClass="p-0">
        {sessions.error ? <div className="p-5"><ErrorBanner text={sessions.error} /></div> : (
          <ul className="divide-y divide-slate-100">
            {list.map(s => (
              <li key={s.id} className="px-5 py-3">
                <div className="flex items-center gap-2 text-sm font-medium text-slate-900">{browserOf(s.user_agent)}{s.current && <Chip tone="green">This browser</Chip>}</div>
                <div className="text-xs text-slate-500">{s.ip_address} · signed in {dateTime(s.created_at)} · last active {ago(s.last_seen_at)}</div>
              </li>
            ))}
          </ul>
        )}
        <div className="flex items-center gap-2 border-t border-slate-100 px-5 py-3 text-xs text-slate-500"><UserCog className="h-3.5 w-3.5" />Admin sessions end after 8 hours.</div>
      </Card>
    </div>
  );
}
